import { PRICE_SELECTED } from 'pu-data/QuoteSteps';

export const buildData = (arg) => {
  const {
    quoteStep,
    variantId,
    projectNumber,
    projectReference,
    parameters,
  } = arg;
  if (quoteStep !== PRICE_SELECTED) return null;

  let form = new FormData();
  form.append('parameters[project_number]', projectNumber);
  form.append('parameters[project_reference]', projectReference);
  form.append('variant_id', variantId);

  Object.keys(parameters).forEach((key) => {
    if (key === 'quantities') {
      parameters[key].forEach((qty) => {
        form.append(`parameters[${key}][]`, qty);
      });
    } else {
      form.append(`parameters[${key}]`, parameters[key]);
    }
  });

  const inputFile = $('#gerber-file')
  const file = inputFile ? inputFile.prop('files')[0] : null

  // If the file is present, it means the user wants to add a new file or replace it for this line item,
  // else we should not send the filename parameter or it will be unlinked in the backend
  if (file) {
    form.append("parameters[filename]", file);
  } else {
    form.delete("parameters[filename]");
  }

  return form;
}

export const buildForms = (args) => {
  if(!args) return [];

  const {quoteStep, variantId, parameters, project_number: projectNumber, project_reference: projectReference} = args;
  const fabrication_form = buildData({quoteStep, variantId, parameters, projectNumber, projectReference});

  return fabrication_form ? [fabrication_form] : [];
}
